<template>
  <div class="fixed top-0 left-1/2 z-30 bg-yellow-500">
    <div class="relative h-4 px-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        class="absolute top-0 -left-4 size-4 rotate-90 text-yellow-500"
        viewBox="0 0 100 100"
      >
        <polygon points="0,0 100,0 0,100" fill="currentColor" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        class="absolute top-0 -right-4 size-4 text-yellow-500"
        viewBox="0 0 100 100"
      >
        <polygon points="0,0 100,0 0,100" fill="currentColor" />
      </svg>
      <div class="flex h-full flex-row items-center justify-center">
        <SvgoPikaWarning class="mr-1 size-2.5 text-yellow-900" />
        <p class="text-xxs font-bold text-yellow-900 uppercase">demo mode</p>
      </div>
    </div>
  </div>
</template>
